import { render, staticRenderFns } from "./PackingNew.vue?vue&type=template&id=1222b9cc"
import script from "./PackingNew.vue?vue&type=script&lang=js"
export * from "./PackingNew.vue?vue&type=script&lang=js"
import style0 from "./PackingNew.vue?vue&type=style&index=0&id=1222b9cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports